import React from 'react';
import { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

interface HexIconProps {
  icon: LucideIcon;
  size?: 'small' | 'medium' | 'large';
  className?: string;
}

export const HexIcon: React.FC<HexIconProps> = ({ 
  icon: Icon, 
  size = 'medium', 
  className = '' 
}) => {
  const sizeClasses = {
    small: 'hex-icon-small',
    medium: 'hex-icon',
    large: 'hex-icon-large'
  };

  const iconSizes = {
    small: 'h-4 w-4',
    medium: 'h-6 w-6',
    large: 'h-8 w-8'
  };

  return (
    <div className={cn(sizeClasses[size], className)}>
      <Icon className={cn(iconSizes[size], 'text-primary')} />
    </div>
  );
}; 